import {
    WithStyles,
    withStyles,
    Button,
    Grid,
    FormControlLabel,
    RadioGroup,
    Radio,
  } from "@material-ui/core";
  import {
    Link,
  } from 'react-router-dom';
  import React, { Component } from "react";
  import { connect } from "react-redux";
  import DateRangePicker from './DateRangePicker' ;
  import SidePanelCard from './SidePanelCard';
  import { userStyles } from '../../content-request/styles';
  import _, { filter } from 'lodash';
  import { Goal } from '../types/interfaces/Goal';
  import {escapeRegExp} from "../helpers/helpers";
  import { FILTERS } from '../Constants/constants';

  interface CourseFiltersPanelProps {
    activeTab: string,
    filters:any,
    onchange:Function,
    classes:any,
    goals: Goal [],
  }
  interface CourseFiltersPanelrState {
    noDataPanel: boolean;
    selectedDateType:any;
    filters:any,
    filteredGoals:any;
    inputValue:string;
    statusType:string;
    showSubFilters: boolean;
    showScroll: boolean;
  }
  
  class CourseFiltersPanel extends Component<CourseFiltersPanelProps, CourseFiltersPanelrState> {
    constructor(props: CourseFiltersPanelProps) {
      super(props);
      this.state = {
        noDataPanel: false,
        selectedDateType:props.filters['dateType'].values.length>0?{key:props.filters['dateType'].values}:'',
        filters:this.props.filters,
        filteredGoals:[],
        inputValue:'',
        statusType:props.filters['statusType'].values,
        showSubFilters: false,
        showScroll: false
      };
    }
    componentDidMount(){
      const event = {
        target: {
          value: ''
        }
      }
      this.getFilteredOptions(event)
    }
    componentDidUpdate(prevProps:CourseFiltersPanelProps,prevState:CourseFiltersPanelrState){
         if(prevProps.filters!==this.props.filters){
           const newFilters={...this.props.filters};
           if(prevState.filters['goals']!==this.props.filters['goals']){
               newFilters['goals'].standardValues=[...prevState.filters['goals'].standardValues];
            }
           this.setState({filters:newFilters});
         }
        if(prevProps.goals!==this.props.goals){
          const event = {
            target: {
              value: ''
            }
          }
          this.getFilteredOptions(event)
        } 
    }
    handleDateType=(selectedOption:any)=>{
       this.setState({selectedDateType:selectedOption},()=>{this.props.onchange('dateType',selectedOption.key)});;
    }
    handleDateSelection=(startDate:any,endDate:any)=>{
      console.log({startDate,endDate});
      this.props.onchange('endDate',endDate);
      this.props.onchange('startDate',startDate);
      
    }
    handleUserChange=(option:string)=>{
      this.props.onchange('userType',option);
    }
    handlePackageChange=(option:string)=>{
      this.props.onchange('packageType',option);
    }
    handleCourseChange = (option: string) => {
      this.props.onchange(FILTERS.COURSE_TYPE, option);
    }
    handleStatusVersion=(option:string)=>{
      this.setState({statusType:option},
        ()=>{ this.props.onchange('statusType',option)});
    }
    handleStatusChange=(option:string)=>{
      this.props.onchange('statusValue',option);
    }
    handleGoalSelect=(option:string)=>{
      this.props.onchange('goals',option);
    }
    renderStatusVersion=()=>{
      const{classes}=this.props;
      const {filters,statusType}=this.state;
      const standardValues=_.get(filters,"statusType.standardValues",[]);
      if(standardValues.length==0){
        return ;
      }
      return (
      <RadioGroup
      name="statusType"
      classes={{
        root: classes.testRadioGroup 
      }}
      className={classes.courseRadioGroup}
      onChange={(_: any, value: string) =>
        this.handleStatusVersion(value)
      }
      value={statusType}
    >
      <FormControlLabel
        control={
          <Radio
            color="primary"
            classes={{ root: classes.testRadioRoot }}
          />
        }
        label={standardValues[0].displayName}
        value={standardValues[0].key}
      />
      <FormControlLabel
        control={
          <Radio
            color="primary"
            classes={{ root: classes.testRadioRoot }}
          />
        }
        value={standardValues[1].key}
        label={standardValues[1].displayName}
      />
    </RadioGroup>
      );  
   }
 
   getFilteredOptions=(event:any)=>{
    const { filteredGoals ,filters} = this.state;
    const{goals}=filters;
    const lowercasedFilter = event.target.value.toLowerCase();
    const regex = new RegExp(escapeRegExp(lowercasedFilter), 'i');
    const options=this.props.goals;
     let filteredData = options.filter(function (datum:any) {
      return (datum['name'].search(regex) > -1);
    });
    const newFilters={...filters};
    const newGoals={...newFilters['goals']};
    if(event.target.value===''){
      filteredData=filteredData.slice(0,3);
    }
    newGoals.standardValues=[...filteredData];
    newFilters['goals']=newGoals;  
    this.setState({ filters:newFilters ,inputValue:event.target.value }, () => {
      if(this.state.inputValue.length > 0){
        this.setState({
          showSubFilters: true
        })
      } else {
        this.setState({
          showSubFilters: false
        })
      }
    });
    if(event.target.value.toLowerCase().length > 0) {
      this.setState({
        showScroll: true
      })
    }
    if(event.target.value.toLowerCase().length === 0) {
      this.setState({
        showScroll: false
      })
    }
   }
   renderGoalFilter=()=>{
    const{filters,inputValue}=this.state;
    const{startDate,endDate,goals}=filters;
    const{classes}=this.props;
    return ( 
      <>
      <Grid container justify="flex-start" alignItems="center">
            <Grid item>
              <div className="search-btn">
              <img
                src="/assets/svg/userManagement/search-icon.svg"
                alt="search"
              />
            </div>
            </Grid>
            <Grid item xs={10} className={classes.customInput}>
              <input type="text"
                onClick={(event: any) => { event.stopPropagation() }}
                onChange={(event: any) => { this.getFilteredOptions(event) }}
                value={inputValue}
                placeholder='Search for goal'
              />
            </Grid>
        </Grid>
      </>
    );
   }
    render() {
      const{filters,filteredGoals, showSubFilters, showScroll, inputValue}=this.state;
      const{startDate,endDate,goals}=filters; 
      return (
        <Grid>
          {filters.dateType && <DateRangePicker
                dropDownObject={filters['dateType']['standardValues']}
                labelKey='displayName'
                valueKey='key'
                selectedDateType={this.state.selectedDateType}
                placeholder='Select Date Type'
                onChangeDropDown={this.handleDateType}
                startDate={startDate.values||''}
                endDate={endDate.values||''}
                setDateFilter={this.handleDateSelection}
            />}
          {filters.statusValue && <SidePanelCard
             extraRender={this.renderStatusVersion}
             title="Status"
             filter={filters}
             onChange={this.handleStatusChange}
             valueKey='key'
             labelKey='displayName' 
             name="statusValue"
             showSubFilters={true}
           />
          }
          {filters.userType && <SidePanelCard
             title="Course For"
             filter={filters}
             onChange={this.handleUserChange} 
             valueKey='key'
             labelKey='displayName'
             name="userType"
             showSubFilters={true}
           />}
          {filters.packageType && <SidePanelCard
             title="Course Type"
             filter={filters}
             onChange={this.handlePackageChange} 
             valueKey='key'
             labelKey='displayName'
             name="packageType"
             showSubFilters={true}
          />}
          {filters.courseType && <SidePanelCard
            title='Course Type'
            filter={filters}
            onChange={this.handleCourseChange}
            valueKey='key'
            labelKey='displayName'
            name={FILTERS.COURSE_TYPE}
            showSubFilters={true}
          />}
          {filters.goals && <SidePanelCard
             extraRender={this.renderGoalFilter}
             title="Goals"
             filter={filters}
             onChange={this.handleGoalSelect} 
             valueKey='_id'
             labelKey='name'
             name="goals"
             allowScroll={showScroll || (inputValue.length === 0 ? false : true)}
             showSubFilters={showSubFilters}
          />}
        </Grid>
      );
    }
  }
  
  const mapStateToProps = (state: any) => ({
    goals: state.courseMangementData.courseManagementReducer.activeGoals,
  });
  
  const mapDispatchToProps = {
  };
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
    // @ts-ignore
  )(withStyles(userStyles)(CourseFiltersPanel));
  